/* LONELY · Recomendador de tallas · lógica de cálculo (sin dependencias)

   La tabla se escribe en el campo "Medidas (cm)" del metaobjeto "Tabla de medidas Lonely Shadow"
   (CSV separado por coma, punto y coma o tabulación). Primera columna: talla. Columnas reconocidas:
     pecho_plano / pecho_contorno (también cintura, cadera, muslo)  → medidas de la prenda
     largo, hombro, manga, ...                                      → medidas informativas
     estatura_min, estatura_max, peso_min, peso_max                 → rangos corporales validados (modo A)
   Filas especiales (en la columna de talla), valores en cm de holgura sobre el contorno corporal:
     holgura_min        → holgura mínima aceptable para el corte (obligatoria para el modo B)
     holgura_ajustado   → holgura objetivo si el cliente prefiere ajustado (opcional)
     holgura_regular    → holgura objetivo para ajuste regular (opcional)
     holgura_oversize   → holgura objetivo para ajuste oversize (opcional)
   Campos del metaobjeto (prioridad): holgura_de_pecho_minima_cm, holgura_de_pecho_maxima_cm, holgura_de_pecho_objetivo_cm,
   recomendacion_validada. Sin «validada» = true los clientes ven selección manual.
   Nunca se inventan márgenes: si falta una regla, el resultado lo indica. */
(function () {
  'use strict';

  var CIRC = ['pecho', 'cintura', 'cadera', 'muslo'];
  var RANGE = ['estatura_min', 'estatura_max', 'peso_min', 'peso_max'];
  var FITS = ['ajustado', 'regular', 'oversize'];
  var SPECIAL = { holgura_min: 'min', holgura_max: 'max', holgura_objetivo: 'target', holgura_ajustado: 'ajustado', holgura_regular: 'regular', holgura_oversize: 'oversize' };

  function norm(s) {
    return String(s == null ? '' : s)
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, '_');
  }

  function sizeKey(s) {
    return String(s == null ? '' : s).trim().toLowerCase();
  }

  function parseTable(raw) {
    var out = { columns: [], rows: [], ease: { min: {}, max: {}, target: {}, ajustado: {}, regular: {}, oversize: {} }, errors: [] };
    out.easeMin = out.ease.min;
    out.easeRegular = out.ease.regular;
    if (!raw || !String(raw).trim()) {
      out.errors.push('empty');
      return out;
    }
    var lines = String(raw).replace(/\r/g, '').split('\n').filter(function (l) { return l.trim() !== ''; });
    var head = lines[0];
    var sep = head.indexOf('\t') > -1 ? '\t' : head.indexOf(';') > -1 ? ';' : ',';
    var cols = head.split(sep).map(norm);
    if (cols.length < 2) {
      out.errors.push('header');
      return out;
    }
    cols.slice(1).forEach(function (c) {
      if (/pulg|inch|(^|_)in$/.test(c)) out.errors.push('units:' + c);
      if (CIRC.indexOf(c) > -1) out.errors.push('ambiguous:' + c);
    });
    out.columns = cols.slice(1).map(function (c) {
      var m = c.match(/^(pecho|cintura|cadera|muslo)_(plano|contorno)$/);
      if (m) return { key: c, body: m[1], factor: m[2] === 'plano' ? 2 : 1, type: 'circ' };
      if (RANGE.indexOf(c) > -1) return { key: c, type: 'range' };
      return { key: c, type: 'length' };
    });
    lines.slice(1).forEach(function (line) {
      var cells = line.split(sep).map(function (x) { return x.trim(); });
      var label = cells[0];
      var nlabel = norm(label);
      var values = {};
      out.columns.forEach(function (col, i) {
        var txt = cells[i + 1];
        if (txt == null || txt === '') return;
        var num = parseFloat(sep === ',' ? txt : txt.replace(',', '.'));
        if (isNaN(num)) {
          out.errors.push('nan:' + label + ':' + col.key);
          return;
        }
        values[col.key] = num;
      });
      if (SPECIAL[nlabel]) {
        var target = out.ease[SPECIAL[nlabel]];
        out.columns.forEach(function (col) {
          if (col.type === 'circ' && values[col.key] != null) target[col.body] = values[col.key];
        });
        return;
      }
      if (!label) return;
      out.columns.forEach(function (col) {
        var v = values[col.key];
        if (v == null) return;
        if (col.type !== 'range' && (v <= 0 || v > 250)) out.errors.push('range:' + label + ':' + col.key);
      });
      var circ = {};
      out.columns.forEach(function (col) {
        if (col.type === 'circ' && values[col.key] != null) circ[col.body] = values[col.key] * col.factor;
      });
      out.rows.push({ size: label, values: values, circ: circ });
    });
    if (!out.rows.length) out.errors.push('norows');
    return out;
  }

  function toNum(v) {
    if (v == null || v === '') return null;
    var n = typeof v === 'number' ? v : parseFloat(String(v).replace(',', '.'));
    return isNaN(n) ? null : n;
  }

  function prepareGuide(g, product) {
    var t = parseTable(g.medidas);
    var opt = findSizeOption(g.opcion, t.rows, product.options);
    var allowed = (g.ajustes || []).map(norm);
    var rangeCols = t.columns.filter(function (c) { return c.type === 'range'; }).map(function (c) { return c.key; });

    /* Regla de holgura de pecho desde los campos del metaobjeto (prioridad sobre las filas del CSV). */
    var fMin = toNum(g.holgura_min);
    var fMax = toNum(g.holgura_max);
    var fObj = toNum(g.holgura_objetivo);
    var ruleErrors = [];
    var fromFields = fMin != null || fMax != null || fObj != null;
    if (fromFields) {
      if (fMin == null) ruleErrors.push('missing_min');
      if (fMax == null) ruleErrors.push('missing_max');
      if (fObj == null) ruleErrors.push('missing_target');
      if (fMin != null && fMax != null && fMin > fMax) ruleErrors.push('min_gt_max');
      if (fObj != null && fMin != null && fObj < fMin) ruleErrors.push('target_below_min');
      if (fObj != null && fMax != null && fObj > fMax) ruleErrors.push('target_above_max');
      if (fMin != null) t.ease.min.pecho = fMin;
      if (fMax != null) t.ease.max.pecho = fMax;
      if (fObj != null) t.ease.target.pecho = fObj;
    }
    CIRC.forEach(function (k) {
      var mn = t.ease.min[k];
      var mx = t.ease.max[k];
      if (mn != null && mx != null && mn > mx && ruleErrors.indexOf('min_gt_max') < 0) ruleErrors.push('min_gt_max');
    });

    var guide = {
      raw: g,
      name: g.nombre || '',
      part: norm(g.parte) === 'inferior' ? 'inferior' : 'superior',
      pattern: norm(g.patron) || 'unisex',
      table: t,
      optionIndex: opt,
      allowFit: {
        ajustado: !allowed.length || allowed.indexOf('ajustado') > -1,
        regular: !allowed.length || allowed.indexOf('regular') > -1,
        oversize: !allowed.length || allowed.some(function (a) { return a.indexOf('oversize') === 0 || a.indexOf('holgado') > -1; })
      },
      measureKeys: CIRC.filter(function (k) {
        return t.ease.min[k] != null && t.rows.some(function (r) { return r.circ[k] != null; });
      }),
      comparableKeys: CIRC.filter(function (k) { return t.rows.some(function (r) { return r.circ[k] != null; }); }),
      hasRanges: rangeCols.length > 0,
      hasHeightRanges: rangeCols.indexOf('estatura_min') > -1 || rangeCols.indexOf('estatura_max') > -1,
      ruleErrors: ruleErrors,
      validated: g.validada === true || g.validada === 'true',
      ignored: [],
      sizes: []
    };
    guide.allowTight = guide.allowFit.ajustado;
    guide.allowRegular = guide.allowFit.regular;
    guide.allowOversize = guide.allowFit.oversize;
    if (opt > -1) {
      var values = product.options[opt].values.map(sizeKey);
      t.rows.forEach(function (r) {
        var idx = values.indexOf(sizeKey(r.size));
        if (idx > -1) {
          r.optionValue = product.options[opt].values[idx];
          guide.sizes.push(r);
        } else {
          guide.ignored.push(r.size);
        }
      });
    }
    guide.valid = !t.errors.length && opt > -1 && guide.sizes.length > 0;
    var bReady = guide.valid && guide.measureKeys.length > 0 && !ruleErrors.length;
    var aReady = guide.valid && guide.hasRanges;
    guide.ruleReady = bReady || aReady;
    guide.modeB = guide.validated && bReady;
    guide.modeA = guide.validated && aReady;
    guide.canRecommend = guide.modeA || guide.modeB;
    /* Regla completa pero sin marcar como validada: solo vista previa en el editor. */
    guide.previewable = !guide.validated && guide.ruleReady;
    guide.bReady = bReady;
    guide.aReady = aReady;
    guide.missing = [];
    if (guide.valid && !guide.canRecommend) {
      if (!guide.ruleReady && !ruleErrors.length) guide.missing.push('rule');
      if (ruleErrors.length) guide.missing = guide.missing.concat(ruleErrors);
      if (guide.ruleReady && !guide.validated) guide.missing.push('not_validated');
    }
    return guide;
  }

  function findSizeOption(name, rows, options) {
    if (!options || !options.length) return -1;
    if (name) {
      for (var i = 0; i < options.length; i++) if (norm(options[i].name) === norm(name)) return i;
    }
    var best = -1;
    var bestHits = 0;
    var sizes = rows.map(function (r) { return sizeKey(r.size); });
    options.forEach(function (o, i) {
      var hits = o.values.filter(function (v) { return sizes.indexOf(sizeKey(v)) > -1; }).length;
      if (hits > bestHits) {
        bestHits = hits;
        best = i;
      }
    });
    return best;
  }

  function inRanges(row, body) {
    var v = row.values;
    var okH = (v.estatura_min == null || body.estatura >= v.estatura_min) && (v.estatura_max == null || body.estatura <= v.estatura_max);
    var okW = (v.peso_min == null || body.peso >= v.peso_min) && (v.peso_max == null || body.peso <= v.peso_max);
    return okH && okW;
  }

  function easeTable(guide, body) {
    return guide.sizes.map(function (row) {
      var e = {};
      guide.comparableKeys.forEach(function (k) {
        if (row.circ[k] != null && body[k] != null) e[k] = Math.round((row.circ[k] - body[k]) * 10) / 10;
      });
      return e;
    });
  }

  /* Holgura = contorno de la prenda (pecho plano × 2) − contorno corporal. La contextura NO interviene.
     opts.preview: calcula con una regla completa aún no validada (solo para el editor).
     status: 'ok' | 'need' | 'nofit' | 'unconfigured' · mode: 'B' (holgura) | 'A' (rangos estatura/peso) */
  function recommend(guide, body, fit, opts) {
    opts = opts || {};
    var res = { status: 'none', warnings: [], used: [], basis: null, mode: null, size: null, index: -1, alt: null, compatible: [], fitUsed: fit, target: null, preview: false, length: null, ease: easeTable(guide, body || {}) };
    var usable = guide.canRecommend || (opts.preview && guide.previewable);
    if (!usable) {
      res.status = 'unconfigured';
      return res;
    }
    res.preview = !guide.canRecommend;
    var useB = guide.canRecommend ? guide.modeB : guide.bReady;
    var useA = guide.canRecommend ? guide.modeA : guide.aReady;
    body = body || {};
    var sizes = guide.sizes;
    var ease = guide.table.ease;
    var fitUsed = guide.allowFit[fit] ? fit : 'regular';
    if (fitUsed !== fit) res.warnings.push('fit_not_allowed');
    res.fitUsed = fitUsed;
    var used = guide.measureKeys.filter(function (k) { return body[k] != null; });
    var candidates = [];
    var idx = -1;
    var score = function () { return 0; };

    if (useB && used.length) {
      res.mode = 'B';
      res.basis = 'measures';
      res.used = used;
      sizes.forEach(function (row, i) {
        var ok = used.every(function (k) {
          if (row.circ[k] == null) return true;
          var e = row.circ[k] - body[k];
          return e >= ease.min[k] - 0.0001 && (ease.max[k] == null || e <= ease.max[k] + 0.0001);
        });
        if (ok) candidates.push(i);
      });
      res.compatible = candidates.slice();
      if (!candidates.length) {
        res.status = 'nofit';
        var allSmall = sizes.every(function (row) { return used.some(function (k) { return row.circ[k] != null && row.circ[k] - body[k] < ease.min[k]; }); });
        res.warnings.push(allSmall ? 'none_fits' : 'none_in_range');
        return res;
      }
      /* Objetivo: fila holgura_<preferencia> del CSV si existe; si no, la holgura objetivo del corte. */
      var tgt = {};
      used.forEach(function (k) {
        if (ease[fitUsed][k] != null) tgt[k] = { v: ease[fitUsed][k], src: 'pref' };
        else if (ease.target[k] != null) tgt[k] = { v: ease.target[k], src: 'cut' };
      });
      var tKeys = Object.keys(tgt);
      if (tKeys.length) {
        res.target = {};
        tKeys.forEach(function (k) { res.target[k] = tgt[k].v; });
        res.targetSrc = tgt[tKeys[0]].src;
        score = function (i) {
          var s = 0;
          tKeys.forEach(function (k) { if (sizes[i].circ[k] != null) s += Math.abs(sizes[i].circ[k] - body[k] - tgt[k].v); });
          return s;
        };
        var best = Infinity;
        candidates.forEach(function (i) {
          var s = score(i);
          if (s < best - 0.0001) {
            best = s;
            idx = i;
          }
        });
      } else {
        idx = candidates[0];
        if (fitUsed !== 'ajustado') res.warnings.push('no_target');
        score = function (i) { return i; };
      }
      /* Largo: solo si la tabla define rangos de estatura por talla (regla validada por LONELY). */
      var v = sizes[idx].values;
      if (guide.hasHeightRanges && body.estatura != null) {
        if (v.estatura_min != null && body.estatura < v.estatura_min) res.length = 'long';
        else if (v.estatura_max != null && body.estatura > v.estatura_max) res.length = 'short';
        else if (v.estatura_min != null || v.estatura_max != null) res.length = 'ok';
      }
    } else if (useA && body.estatura != null && body.peso != null && !useB) {
      res.mode = 'A';
      res.basis = 'ranges';
      sizes.forEach(function (row, i) { if (inRanges(row, body)) candidates.push(i); });
      res.compatible = candidates.slice();
      if (!candidates.length) {
        res.status = 'nofit';
        res.warnings.push('outside_ranges');
        return res;
      }
      idx = candidates[0];
      score = function (i) { return i; };
      if (candidates.length > 1) res.warnings.push('ranges_overlap');
    } else {
      res.status = 'need';
      res.need = useB ? guide.measureKeys[0] : 'estatura_peso';
      return res;
    }

    res.status = 'ok';
    res.index = idx;
    res.size = sizes[idx];
    /* Alternativa: la otra talla compatible más cercana al objetivo. */
    var others = candidates.filter(function (i) { return i !== idx; });
    if (others.length) {
      others.sort(function (a, b) { return score(a) - score(b) || a - b; });
      var ai = others[0];
      res.alt = { row: sizes[ai], index: ai, dir: ai < idx ? 'smaller' : 'larger' };
    }
    return res;
  }

  window.LonelySizeCore = { parseTable: parseTable, prepareGuide: prepareGuide, recommend: recommend, easeTable: easeTable, norm: norm, sizeKey: sizeKey, CIRC: CIRC, FITS: FITS };
})();
